export const CampaignStatus = {
  live: 'Live',
  test: 'Test',
  default: 'Default'
};
